// extracted by mini-css-extract-plugin
export default {"container":"InfoPackageForm_container__iqdbl","header":"InfoPackageForm_header__Y5TiK"};